<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';

    const props = defineProps<{
        class?: HTMLAttributes['class'];
    }>();
</script>

<template>
    <div
        data-slot="alert-dialog-header"
        :class="cn('flex flex-col gap-2 p-5', props.class)"
    >
        <slot />
    </div>
</template>
